import {AbstractRefsService} from "./abstract-refs.service";
import {Injectable} from "@angular/core";
import {SpecializationModel} from "../models/specialization.model";


export class SpecialziationService extends AbstractRefsService {
    refName: string = 'spec';

    public getSpecializations(): Promise<SpecializationModel[]> {
        return this.getListAll({}, 'sorder,title');
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
